<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import { mapActions } from "vuex";

export default {
  name: "App",
  methods: mapActions([
    "refreshMe",
    "masterRefreshMe",
    "adminRefreshMe",
    "uncleRefreshMe",
    "refreshQuestion",
    "refreshBroadcast",
    "refreshSaibs",
    "refreshWholesales",
    "refreshPending"
  ]),
  mounted() {
    const { path } = this.$router.currentRoute;
    if (
      !path.startsWith("/admin") &&
      !path.startsWith("/uncle") &&
      !path.startsWith("/master") &&
      !path.startsWith("/req") &&
      !path.startsWith("/find")
    ) {
      clearInterval(window.refreshMe);
      clearInterval(window.refreshSaibs);
      clearInterval(window.refreshQuestion);
      clearInterval(window.refreshBroadcast);
      clearInterval(window.refreshWholesales);
      clearInterval(window.adminRefreshMe);
      clearInterval(window.uncleRefreshMe);
      clearInterval(window.unclePending);
      clearInterval(window.masterRefreshMe);

      this.refreshMe();
      window.refreshMe = setInterval(this.refreshMe, 1000 * 60);
      window.refreshSaibs = setInterval(this.refreshSaibs, 1000 * 60);
      window.refreshQuestion = setInterval(this.refreshQuestion, 1000 * 60);
      window.refreshBroadcast = setInterval(this.refreshBroadcast, 1000 * 60);
      window.refreshWholesales = setInterval(this.refreshWholesales, 1000 * 60);
    } else if (path.startsWith("/admin") && !path.startsWith("/admin/find")) {
      clearInterval(window.refreshMe);
      clearInterval(window.refreshSaibs);
      clearInterval(window.refreshQuestion);
      clearInterval(window.refreshBroadcast);
      clearInterval(window.refreshWholesales);
      clearInterval(window.adminRefreshMe);
      clearInterval(window.uncleRefreshMe);
      clearInterval(window.unclePending);
      clearInterval(window.masterRefreshMe);

      this.adminRefreshMe();
      window.adminRefreshMe = setInterval(this.adminRefreshMe, 1000 * 60);
    } else if (path.startsWith("/uncle") && !path.startsWith("/uncle/find")) {
      clearInterval(window.refreshMe);
      clearInterval(window.refreshSaibs);
      clearInterval(window.refreshQuestion);
      clearInterval(window.refreshBroadcast);
      clearInterval(window.refreshWholesales);
      clearInterval(window.adminRefreshMe);
      clearInterval(window.uncleRefreshMe);
      clearInterval(window.unclePending);
      clearInterval(window.masterRefreshMe);

      this.uncleRefreshMe();
      window.uncleRefreshMe = setInterval(this.uncleRefreshMe, 1000 * 60);
      window.unclePending = setInterval(this.unclePending, 1000 * 60);
    } else if (path.startsWith("/master")) {
      clearInterval(window.refreshMe);
      clearInterval(window.refreshSaibs);
      clearInterval(window.refreshQuestion);
      clearInterval(window.refreshBroadcast);
      clearInterval(window.refreshWholesales);
      clearInterval(window.adminRefreshMe);
      clearInterval(window.uncleRefreshMe);
      clearInterval(window.unclePending);
      clearInterval(window.masterRefreshMe);

      this.masterRefreshMe();
      window.masterRefreshMe = setInterval(this.masterRefreshMe, 1000 * 60);
    }
  }
};
</script>
<style>
.ant-badge-count {
  z-index: 2;
}
.ant-layout-content {
  margin: 0 !important;
}

.exchange-color-0 {
  /* 접수 */
  border: 20px solid #fff;
  padding: 0;
}

.exchange-color-1 {
  /* 처리 중 */
  border: 20px solid #6da3ff;
  padding: 0;
}

.exchange-color-2 {
  /* 성공 */
  border: 20px solid #519459;
  padding: 0;
}

.exchange-color-3 {
  /* 실패 */
  border: 20px solid #cf7373;
  padding: 0;
}

.exchange-color-4 {
  /* 대기 */
  border: 20px solid #c7a644;
  padding: 0;
}

.admin-color-0 {
  /* 접수 */
  background: #fff;
  color: #000;
}

.admin-color-1 {
  /* 처리 중 */
  background: #6da3ff;
  color: #fff;
}

.admin-color-2 {
  /* 성공 */
  background: #519459;
  color: #fff;
}

.admin-color-3 {
  /* 실패 */
  background: #cf7373;
  color: #fff;
}

.admin-color-4 {
  /* 대기 */
  background: #f7d366;
  color: #fff;
}
</style>
